import { render } from "./BlockAnimation.vue?vue&type=template&id=495257d7"
import script from "./BlockAnimation.vue?vue&type=script&lang=js"
export * from "./BlockAnimation.vue?vue&type=script&lang=js"

import "./BlockAnimation.vue?vue&type=style&index=0&id=495257d7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__